import { bannerVisible, promptInstall, dismissInstallBanner, isIOS } from '@/pwa/install';
import css from './InstallBanner.module.css';

/**
 * Закрываемый баннер-предложение установить приложение.
 * Показывается после логина на Android (когда система готова) и на iOS (всегда).
 * Скрывается на 7 дней после закрытия.
 */
export function InstallBanner() {
  if (!bannerVisible.value) return null;

  return (
    <div class={css.banner} role="region" aria-label="Установка приложения">
      <div class={css.text}>
        <div class={css.title}>Установите приложение</div>
        <div class={css.subtitle}>
          {isIOS.value
            ? 'Быстрый доступ с экрана «Домой» и уведомления о заказах'
            : 'Работает как обычное приложение — без браузера, с уведомлениями'}
        </div>
      </div>
      <button type="button" class={`btn btn-primary btn-sm ${css.action}`} onClick={() => promptInstall()}>
        Установить
      </button>
      <button
        type="button"
        class={css.close}
        onClick={dismissInstallBanner}
        aria-label="Скрыть предложение"
      >
        <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none" aria-hidden="true">
          <path d="M6 6 L18 18 M18 6 L6 18" />
        </svg>
      </button>
    </div>
  );
}
